// @codekit-prepend "../../node_modules/jquery/dist/jquery.js";
// @codekit-prepend "../../node_modules/foundation-sites/dist/js/foundation.min.js";

jQuery(function ($) {
  // Call the pretty Foundation scripts
  $(document).foundation();

  $(".link-box").on("click", function () {
    if ($(this).find("a").length) {
      window.location.href = $(this).find("a:first").attr("href");
    }
  });

  if($('#tabs-ct-1').length) {
    $('#tabs-ct-1').foundation('_openTab', $('.tabs-title:first-child'));
  }

  $("#expandAll").on("click", function() {
    $(".accordion .accordion-item").removeClass("is-active").addClass("is-active");
    $(".accordion .accordion-item .accordion-title").attr("aria-expanded", true).attr("aria-selected", true);
    $(".accordion .accordion-item .accordion-content").css('display', 'block');
  });

  var $eventTypeButtons = $(".hero__event-filter-list input:radio[name=eventType]");
  var $eventTypeSearch = $(".hero__event-filter-button");

  $eventTypeButtons.on("focus", function () {
    $eventTypeSearch.removeClass("hide");
    $eventTypeSearch.attr("href", "/search/?keywords=" + $(this).val());
    $eventTypeSearch.text($(this).val());
  });

});
